import React from 'react'

import Button from './Button';
import Heading from './Heading';
import Tag from './Tag';

const Tile = (props) => {
  return (
    <Button ReducedMotion = {props.ReducedMotion} setHover={props.setHover} link={props.link}>
      <div className='flex flex-col justify-start items-start min-h-fit h-full w-full'>
        <div className='w-full pl-[3px] border-l-[1px] border-l-blue flex flex-col'>
          <div className='w-[100%] h-[10rem] overflow-hidden p-[0.5rem] border-l-[1px] border-l-blue'>
          {
            props.cover
            ?
            <img className='w-full h-full object-cover object-top dropshadow' src={props.cover} alt={props.title}/>
            :
            <img className='w-full h-full object-cover object-top dropshadow' src='https://portfolioassets-454216831813-us-east-1-an.s3.us-east-1.amazonaws.com/sand.png' 
            alt={props.title}/>
          }
        </div>
          <div className='w-full min-h-fit flex flex-col border-l-[1px] border-l-blue pl-[0.5rem] pt-[0.5rem]'>
            <div className='flex flex-col items-start'>
              <div className='text-blue keplersemi text-[24px] leading-tight
                              w-full'>{props.title}</div>
              <div className='keplermed whitespace-nowrap text-sm'>{props.dates}</div>
            </div>
            <div className='flex w-full min-h-fit py-[0.5rem] justify-start items-start flex-wrap'>
              {
                props.tags.map((t)=>(
                  <Tag text={t}/>
                ))
              }
            </div>
          </div>
        </div>
      </div>
    </Button>
  )
}

export default Tile